import React from "react";
import { CloudWaveEffect } from "react-background-animation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function MySkills() {
  return (
    <section id="mySkills">
      <CloudWaveEffect />

      <div className="container-fluid features">
        <div className="container cf">
          <h2><u>Skills & Experience</u></h2><br></br><br></br>

          <h3 className="intro-text">
            That's a fantastic foundation! Passionate, engaged, caring, and driven individuals can bring a lot of energy and commitment to any endeavor. We are committed to educational excellence, offering years of experience in classroom management, curriculum enhancement, and mentoring educators to achieve measurable student success.
          </h3><br></br><br></br>

          <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={50}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="skills-swiper"
            >
            <SwiperSlide className="skill-card">
              <h3>#1 - Expert tutors</h3>
              <p>
              Our expert tutors are like superheroes of knowledge, leading the way for students to learn & grow. They're really good at teaching and making sure everyone understands & feels confident in what they're learning. Expert Tutors & Exceptional Results with Expert Guidance.
              </p>
            </SwiperSlide>

            <SwiperSlide className="skill-card">
              <h3>#2 - Share knowledge</h3>
              <p>
              AB4S offers classes in Math, Physics, Chemistry, and Biology for all curricula, covering IGCSE, GCSE, IBMYP, IBDP, State syllabus, and CBSE from classes 8 to 12. We also provide career counseling to help students navigate their educational journey and future paths.
              </p>
            </SwiperSlide>

            <SwiperSlide className="skill-card">
              <h3>#3 - Trust</h3>
              <p>
              AB4S is committed to building trust and helping you find the perfect teacher—someone who brings passion, expertise, and a true dedication to your learning journey. AB4S bringing unmatched expertise, passion, and a true commitment to your success.
              </p>
            </SwiperSlide>

            <SwiperSlide className="skill-card">
              <h3>#4 - Learn confidently</h3>
              <p>
              Empower yourself and learn confidently, knowing that your journey is supported by a dedicated and knowledgeable team committed to your success  - AB4S offer the best in education to learn, share confidently and student engagement to foster effective learning outcomes.
              </p>
            </SwiperSlide>
            <SwiperSlide className="skill-card">
              <h3>#5 - Customer Satisfaction</h3>
              <p>
              With AB4S, you’re not just finding a teacher—you’re forming a partnership with a mentor committed to making your learning experience meaningful, rewarding, and transformative.Your satisfaction matters to us, and we’re here to support you every step of the way.
              </p>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </section>
  );
}
